import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { get } from "api";
import { PreparingScreen } from "modules/personalisation/components/PreparingScreen";

import { PersonalisationWelcomeContainer_PATH } from "./PersonalisationWelcomeContainer";

export const PreparingScreenContainer_PATH = "/personalise/preparing" as const;

export function PreparingScreenContainer() {
  const navigate = useNavigate();

  const { data: user } = useQuery({
    queryKey: ["/user"],
    queryFn: () => get("/user"),
    staleTime: 1000 * 60 * 2,
  });

  useEffect(() => {
    const id = setTimeout(
      () => navigate(PersonalisationWelcomeContainer_PATH),
      7000
    );
    return () => clearTimeout(id);
  }, [navigate]);

  return <PreparingScreen durationMs={1200} userFirstName={user?.firstName} />;
}
